const initialState = {
  rowData: null,
  action: null,
};

const commonRowData = (state = initialState, action) => {
  switch (action.type) {
    case 'SET_ROW_DATA':
      return {
        ...state,
        rowData: action.payload.rowData,
        action: action.payload.action,
      };
    default:
      return state;
  }
};

export default commonRowData;
